import { InlineButton } from './InlineButton';
import { InlineInput } from './InlineInput';
export const InlineControl = {
    Input: InlineInput,
    Button: InlineButton
};
